import { APIClient } from '@frontend/api-utils';

export class ReportEnumClient extends APIClient {
    public static readonly endpoint = '/report-api/v1';

    public static async fetchReportTypes(): Promise<string[]> {
        const res = await this.fetch(`${this.endpoint}/report-types`);
        return await this.handleResponse<string[]>(res);
    }
}
